import { helper } from '@ember/component/helper';

import { wrap } from 'rise-ui/utils/function.js';
import { isSet } from 'rise-ui/utils/nullish.js';
import { isArray } from 'rise-ui/utils/array.js';

export default helper(function filterHelper([ params ], { filter, set, pop, unshift, length, concat }) {
  params = concat ? [].concat(params || [])
    : isArray(params) ? params : [params];
  filter = wrap([filter, () => true]);
  set = !!set;
  pop = params.length - (pop || 0);
  unshift = unshift || 0;
  length = length || length === 0 ? length : params.length;
  let n = 0;
  return params.filter( (v, i, a) =>
    ++n <= length && i >= unshift && i < pop
      && (set ? isSet(v) : v) && filter(v, i, a)
  );
});
